// <> Read configs
const response = await fetch(`${process.env.REACT_APP_CONFIG_READER_URL}/?secret=${process.env.REACT_APP_CONFIG_READER_SECRET}&env=${process.env.REACT_APP_CLOUD_ENV}`);
if (!response.ok) throw new Error(`Response status: ${response.status}`);
export const configs = await response.json();
// </> Read configs

async function checkUrlExists(checkingUrl) {
    return await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('HEAD', checkingUrl, true);
        xhr.onload = function () {
            if (xhr.status === 200) {
                resolve(true);
            } else {
                resolve(false);
            }
        };
        xhr.onerror = function () {
            resolve(false);
        }
        xhr.send();
    });
}

export async function getVideoUrl(exerciseId) {
    let primary = '';
    let fallback = '';
    if (configs.cloud.isProduction) {
        primary = `https://media.wizecare.com/vtexercisevideos/white/en/${exerciseId}.mp4`;
        fallback = `https://storage.googleapis.com/wize-storage-dev/vtexercisevideos/white/en/${exerciseId}.mp4`;
    } else {
        primary = `https://storage.googleapis.com/wize-storage-dev/vtexercisevideos/white/en/${exerciseId}.mp4`;
        fallback = `https://media.wizecare.com/vtexercisevideos/white/en/${exerciseId}.mp4`;
    }

    if (await checkUrlExists(primary)) {
        return primary;
    } else {
        return fallback;
    }
}

export const lookerStudioReportSessionGraphsLab = (moveAiSessionIds) => configs.internal.lookerStudioReportSessionGraphsLab.replace('{{moveAiSessionIds}}', moveAiSessionIds);
export const inspectorLogsUrl = (traceId, projectId) => configs.internal.moveAiLabInspectorLogsUrl.replace('{{traceId}}', traceId).replace('{{projectId}}', projectId);
export const openTokInspectorUrl = (sessionId) => configs.internal.openTokInspectorUrl.replace('{{openTokApiKey}}', configs.internal.openTokApiKey).replace('{{sessionId}}', sessionId);
export const moveAiInitiateUrl = configs.internal.moveAiInitiateUrl;

export default {
    OT_API_KEY: configs.internal.openTokApiKey,
    GET_TRACE_DATA_FUNC_URL: configs.internal.getMaasTraceDataFunctionUrl,
    PROJECT_ID: configs.public.firebase.projectId,
    serverUrl: `${configs.public.backend}/vt/api/dispatcher.php`,
}
